import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './UserOnboardingPage.css'; 
import SignUpUserHeader from "../../components/header/SignUpUserHeader";
import TermsModal from './TermsModal';
import {notification, Col, Row } from "antd";
const TermsAndConditions = ({ onboardingData }) => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  
  const showModal = () => {
    setIsModalVisible(true);
  };
  
  const handleClose = () => {
    setIsModalVisible(false);
  };
  
  const [agreed, setAgreed] = useState(false);
  
  useEffect(() => {
    const savedAgreed = localStorage.getItem('agreed') === 'true';
    setAgreed(savedAgreed);
  }, []);
  
  useEffect(() => {
    localStorage.setItem('agreed', agreed);
  }, [agreed]);
  
  const handleAgree = async () => {
    if (agreed) {
      navigate('/onboarding/personal-info');
    } else {
      notification.warning({
        message: 'Warning',
        description: 'You must agree to the terms and conditions before proceeding.',
      });
    }
  };
  const handleBack = () => {
    navigate('/onboarding/welcome');
  };
  return (
    <Row className="welcome-onboarding-row" style={{ background: "#fefcfe" }}>
      <Col lg={24}>
        <SignUpUserHeader />
      </Col>
      <Row gutter={24} className="welcome-onboarding-row-card-container">
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          className="welcome-onboarding-inner-content-col"
        >
          <div className="onboarding-step">
            <h1>Terms & Conditions</h1>
            <p>
              Please read the following terms and conditions carefully before
              proceeding.
            </p>
            <div className="terms-container">
              <a
                href="#"
                onClick={showModal}
                style={{ color: "#1890ff", textDecoration: "underline" }}
              >
                Terms and Conditions
              </a>
              <h5>Do you agree to the terms & conditions?</h5>
              <label>
                <input
                  type="checkbox"
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                />
                Yes, I agree to the terms and conditions provided.
              </label>
              <TermsModal visible={isModalVisible} onClose={handleClose} />
            </div>
            <div className="button-container">
              <button
                className="back-button"
                onClick={handleBack}
                type="button"
              >
                Back
              </button>
              <button type="button" onClick={handleAgree}>
                Next
              </button>
            </div>
          </div>
        </Col>
      </Row>
    </Row>
  );
};
export default TermsAndConditions;